/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Reset_Password__SubmitInputs */

const en_auth__reset_password__submit = /** @type {(inputs: Auth__Reset_Password__SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset password`)
};

/**
* | output |
* | --- |
* | "Reset password" |
*
* @param {Auth__Reset_Password__SubmitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__reset_password__submit = /** @type {((inputs?: Auth__Reset_Password__SubmitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Reset_Password__SubmitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__reset_password__submit(inputs)
});